// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"87":"jobs","189":"select-organization","293":"create-organization","302":"flows","454":"applications","516":"team","589":"live-streams","597":"projects","658":"project-overview","777":"application-overview","898":"replications","915":"file-manager","966":"login"}[chunkId] + ".chunk.min.js";
};